<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

	<p-toolbar>
		<ng-template pTemplate="start">
			<div class="flex items-center gap-2 toolbar-menu">
				<p-selectButton [options]="modes" [(ngModel)]="selectedMode"
					(onChange)="onModeChange($event)" [allowEmpty]="false">
				</p-selectButton>

				<p-selectButton [options]="resultsDisplay" [(ngModel)]="selectedResultDisplay"
					(onChange)="onSelectedResultDisplayUpdated($event)" [allowEmpty]="false">
				</p-selectButton>

				@if (selectedResultDisplay === 'plot') {
					<p-selectButton [options]="depthView"
						[(ngModel)]="selectedDepthView" (onChange)="depthViewToggle($event)"
						[allowEmpty]="false">
					</p-selectButton>
				}

				<app-single-load-results [loadCases]="loadCases" (loadCaseSelected)="setLoadCase($event)"
					[stateStore]="hollidayStressRatioStore" [signalRChange]="signalRChange">
				</app-single-load-results>
			</div>
		</ng-template>
	</p-toolbar>

	@if (selectedResultDisplay === 'plot') {
		<app-single-load-plot
			[yAxisTitle]="yAxisTitle"
			[xAxisTitle]="xAxisTitle" [columnDefs]="columnDefs" [data]="results"
			[selectedDepthView]="selectedDepthView" [depthUnit]="longLengthUnit" [plotName]="plotName"
			[plotTitle]="'Holliday Stress Ratio Results'"
			[singleLoadPlotStore]="hollidayStressRatioStore">
		</app-single-load-plot>
	}

	<app-single-load-grid
		[hidden]="selectedResultDisplay !== 'grid'"
		[rowData]="results"
		[columnDefinitions]="columnDefinitions"
		[hollidayStressRatio]="hollidayStressRatio"
		tableName="Single Load Holliday Stress Ratio"
		gridName="Holliday Stress Ratio Results"
	>
	</app-single-load-grid>

	<p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
		<i class="pi pi-exclamation-circle pr-1"></i>
		<label>{{ errorMsg }}</label>
		<br />
		<br />
	</p-dialog>

	@if (hollidayStressRatioResults != null) {
		<app-perivis-validation [errors]="hollidayStressRatioResults[0]?.errors" />
	}

</app-tool-loader>
